const namespace = "myApp";

import AppConfig from "@/_config/application-config"
import childRoutes from "./routes"
import BrowserStorage from "@/_util/storage-modes.browser-storage";

const localStorage = new BrowserStorage(namespace);
const sessionStorage = new BrowserStorage(namespace, true);

const appConfig = {
  // "namespace" : {
  name: "My App",
  namespace,
  description: null,
  version: "0.1.0",
  icon: "mdi-gauge",
  parentRoute: "/my-app",
  defaultRoute: "helloworld",
  accentColor: "#000080",
  childRoutes,
  component : () => import(/* webpackChunkName: "myapp-parent" */ "@/apps/my-app/Application.vue"),
  navigation: [{
      title: "Hello World",
      route: "helloworld",
      icon: "mdi-hand",
    },
    {
      title: "Todo List",
      route: "todolist",
      icon: "mdi-help-circle",
    },
    {
      title: "Config",
      route: "configuration",
      icon: "mdi-hammer-wrench",
    },
  ],
  settings : {
    apiUrl: "https://as-refapp9-api-sbox.azurewebsites.net",
    clientId : "d81b245c-6e9c-4bdd-95a4-48e2efded1da",
    scope : "api://d81b245c-6e9c-4bdd-95a4-48e2efded1da/Read.All",
    authorizeUrl : "https://login.microsoftonline.com/fbe62081-06d8-481d-baa0-34149cfefa5f/oauth2/v2.0/authorize",
    tokenUrl : "https://login.microsoftonline.com/fbe62081-06d8-481d-baa0-34149cfefa5f/oauth2/v2.0/token",
    logoutUrl : `https://login.microsoftonline.com/fbe62081-06d8-481d-baa0-34149cfefa5f/oauth2/v2.0/logout?post_logout_redirect_uri=${window.location.origin}`,
  },
  store: {
    //The store is made up of settings and attributes that should be accessible across components.
    //One common scenario would be user settings or profile preferences.  Some examples:
    //Date and Time Formats
    //Preferred configuration of a table view
    //Preferred theme color.
    themeColor : {
      default: "red",
      storageMode : localStorage,
    },
    isTrue : {
      default: true,
      storageMode : sessionStorage,
    },
    userDetails : {
      default: {},
      storageMode : sessionStorage,
    },
  }

}

export default AppConfig.merge(appConfig);


